import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

export const sideLoadedBusinessSerializeMap: SerializeMap<SideLoadedBusiness> =
  {
    id: "id",
    name: "name",
    abn: "abn",
    brands: "brands",
    email: "email",
    pics: "pics",
    isIgnored: "is_ignored",
    rawData: "raw_data",
    datasetName: "dataset_name",
    businessIds: "business_ids",
  };

export const serializeSideLoadedBusiness = buildSerializer(
  sideLoadedBusinessSerializeMap,
  "sideLoadedBusiness",
);

export const deserializeSideLoadedBusiness = buildDeserializer(
  sideLoadedBusinessSerializeMap,
  "sideLoadedBusiness",
);
